import type { AxiosInstance } from "axios";

export function configureHeaders(axios: AxiosInstance) {
  axios.defaults.headers.put["Content-Type"] = "application/json";
  axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("b2cToken")}`;
}
